export default {"src":"/_next/static/media/search.df98a545.svg","height":25,"width":25};